// removed by extract-text-webpack-plugin
module.exports = {"dragElement":"_15qG8Va38KCykntn2nrOG4"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/DragNDrop/Drag/index.css
// module id = 198
// module chunks = 0